import React, { useEffect, useState } from "react";
import Spinner from "../../../components/_common/Spinner";
import { useAppDispatch, useAppSelector } from "../../../redux/store/storehooks";
import { getMiscellaneousFunctions } from "../../../api/api";
import { UpdateMiscellaneousFunctions } from "../../../redux/reducers/MiscellaneousFunctionsSlice";
import { errorNotify } from "../../../services/toast.notification";

export interface InputProps {
  url: any,
}

const RAMUsage = ({url}: InputProps) => {
     
    const myStore = useAppSelector((state: any) => state)
    const dispatch = useAppDispatch();
    const [isloading,setIsLoading] = useState(true);
  
    const _getRamUsage = (url:string,func:number,fromdate:string,todate:string) => {
      getMiscellaneousFunctions(url,func,fromdate,todate)
      .then((result:any) => {
        let jsonResult = JSON.parse(result.data.json);
        dispatch(UpdateMiscellaneousFunctions({ ramusage:jsonResult.Memory}))
        setIsLoading(false);
      })
      .catch((error:any) => {
        console.log(error);
        errorNotify(error.response.data.errorMessage,undefined,5000)
      }) 
      
      
  }
  
    useEffect(() => {
        _getRamUsage(url,1,'','');
    }, [])

    let data = myStore.miscellaneousList.ramusage;
    return (
    <div className="tab-content-padding">

      {
      
      isloading === false && (
        <>
        <div className="row" >
            <p>
                 AvailablePhysicalMemory:           
                {data[0].AvailablePhysicalMemory}             
            </p>
        </div>
        <div className="row" >
            <p>
                TotalMemory:
                {data[0].TotalMemory} 
            </p>
        </div>
         <div className="row" >
            <p>
                 Free:
                {data[0].Free} </p>
         </div>
         <div className="row" >
         <p>
            Occupied:
            {data[0].Occupied} 
            </p>
        </div>
       
  </>
      )}

      {isloading === true && (
        <Spinner />
      )}

    </div>
  )

};

export default RAMUsage;
